import apiService from './apiService';

/**
 * Stripe billing (payments cards #297-#299).
 *
 * Both calls return `{ url }` — a Stripe-hosted page the caller redirects the
 * whole window to (Checkout for a new subscription, the Customer Portal for
 * changing/cancelling an existing one). Errors carry `.status`/`.body` from
 * apiService, so a 409 `already_subscribed` on checkout is the signal to fall
 * through to the portal.
 */
const billingService = {
    async createCheckout(plan) {
        return apiService.post('/api/billing/checkout', { plan });
    },

    async createPortal() {
        return apiService.post('/api/billing/portal', {});
    },
};

export default billingService;
